<template>
  <div
      v-if="open"
  >
    <div class="dummy"/>
    <div class="cookies">
      <div class="message">
        <span>
          {{this.$t('cookies.basic.message')}}
        </span>
      </div>
      <div class="btn">
        <button
            class="btn_w"
            @click="handleSettingClick"
        >
          {{this.$t('cookies.basic.btn01')}}
        </button>
        <button
            class="btn_b"
            @click="handleAcceptClick"
        >
          {{this.$t('cookies.basic.btn02')}}
        </button>
      </div>
    </div>
    <DetailSetting
        v-if="detailOpen"
        @onAccept="handleAccept"
        @onClose="handleClose"
    />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { getCookie } from '@/static';
import method from './method';

export default {
  name: 'cookies',
  components: {
    DetailSetting: () => import('./detailSetting'),
  },
  props: [],
  data() {
    // 초기 데이터
    return {
      detailOpen: false,
      open: false,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.$i18n.locale = this.languageSetting();

    const essential = getCookie('essentialCookies') === '1';
    const functional = getCookie('functionalCookies') === '1';
    const performance = getCookie('performanceCookies') === '1';

    essential && this.essential();
    functional && this.functional();
    performance  && this.performance();

    this.checkDeleteCookie(functional, performance);
    if (!essential) {
      if (navigator.cookieEnabled) {
        localStorage.setItem('refreshToken', '');
        localStorage.setItem('accessToken', '');
        localStorage.setItem('fcmToken', '');
        document.cookie = '';
      }

      this.$router.push('/login');
    }

    this.open = !essential;
  },
  methods: {
    ...method,
    ...mapActions(['changeUnitToVueX']),
    handleAcceptClick() {
      this.acceptAll();
      this.open = false;
    },
    handleSettingClick() {
      this.detailOpen = true;
    },
    handleAccept(performanceCookies, functionalCookies) {
      this.accept(performanceCookies, functionalCookies);
      this.detailOpen = false;
      this.open = false;
    },
    handleClose() {
      this.detailOpen = false;
    },
  },
}
</script>
<style lang="scss">
.dummy {
  z-index: 1000000;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000000;
  opacity: 0.2;
}

.cookies {
  z-index: 1000001;
  position: fixed;
  bottom: 0;
  padding: 32px 3%;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;

  .message {
    width: calc(100% - 300px);
    height: 76px;
    flex-grow: 0;
    margin: 0 0 0 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #222;
    float: left;
    display: flex;
    align-items: center;

    span {
      vertical-align: middle;
      width: 100%;

      word-break: keep-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }

  .btn {
    width: 250px;
    height: 54px;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
    margin: 11px 0 11px 0px;
    padding: 0;
    float: right;

    .btn_w {
      border: 0;
      cursor: pointer;
      width: 103px;
      height: 54px;
      align-items: center;
      padding: 10px 20px;
      border-radius: 2px;
      background-color: #fff;
      font-size: 14px;
      text-align: center;
      color: #2a589f;
      word-break: keep-all;
    }

    .btn_w:hover {
      text-decoration: none;
      background-color: rgba(0, 0, 0, 0.04);
    }

    .btn_b {
      border: 0;
      cursor: pointer;
      width: 137px;
      height: 54px;
      align-items: center;
      text-align: center;
      padding: 10px 20px;
      border-radius: 2px;
      background-color: #2a589f;
      font-size: 14px;
      color: #fff;
      word-break: keep-all;
    }

    .btn_b:hover {
      background-color: #1d4486;
    }
  }
}
</style>